import { S as Swiper } from './swiper-core.js';
import { P as Pagination } from './swiper-pagination.js';
import './swiper-classes-to-selector.js';
import './swiper-create-element.js';

class FeaturedCollectionsSlider extends HTMLElement {
  connectedCallback() {
    // Wait for next frame to ensure container has dimensions
    requestAnimationFrame(() => {
      this.initSwiper();
    });

    // Listen for block select events in Shopify editor
    this.boundHandleBlockSelect = this.#handleBlockSelect.bind(this);
    document.addEventListener('shopify:block:select', this.boundHandleBlockSelect);
  }

  initSwiper() {
    const swiperElement = this.querySelector('.swiper--featured-collections');

    if (!swiperElement) {
      return;
    }

    const wrapper = swiperElement.querySelector('.swiper-wrapper');
    this.slides = wrapper ? Array.from(wrapper.querySelectorAll('.swiper-slide')) : [];

    const loopSetting = this.dataset.loop === 'true';
    const pagination = this.dataset.pagination === 'true';

    const config = {
      modules: [Pagination],
      spaceBetween: 16,
      slidesPerView: 1.2,
      loop: loopSetting && this.slides.length > 1,
      breakpoints: {
        768: {
          slidesPerView: 2.2,
          loop: loopSetting && this.slides.length > 2,
        },
        1024: {
          slidesPerView: 4.2,
          loop: loopSetting && this.slides.length > 4,
        },
        1440: {
          slidesPerView: 5,
          loop: loopSetting && this.slides.length > 5,
        },
      },
    };

    if (pagination) {
      config.pagination = {
        el: '.swiper-pagination',
        clickable: true,
      };
    }

    this.swiper = new Swiper(swiperElement, config);
  }

  #handleBlockSelect(event) {
    if (!this.swiper) {
      return;
    }

    const slide = event.target.closest('.swiper-slide');
    if (!slide || !this.contains(slide)) {
      return;
    }

    const slideIndex = this.slides.indexOf(slide);
    if (slideIndex === -1) {
      return;
    }

    this.swiper.slideTo(slideIndex);
  }
}

customElements.define('featured-collections-slider', FeaturedCollectionsSlider);
